"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { resetPasswordEmail } from "@/lib/centra/selectionFunctions";
import { CentraJS } from "@frend-digital/centra-js-client";

export default function useResetPasswordEmail() {
  const queryClient = useQueryClient();
  const resetPassword = useMutation({
    mutationFn: resetPasswordEmail,
    onError: async (error: Error) => {
      return error;
    },
    onSuccess: async (data) => {
      queryClient.setQueryData(["selection"], data);
      queryClient.invalidateQueries({
        queryKey: ["selection"],
      });
    },
    onSettled: () => {
      CentraJS.resume();
    },
  });
  return { resetPassword };
}
